import React from 'react';
import { withRouter } from 'react-router-dom';
import { reduxForm, Field, change } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Btn } from './../../../components/includes/ui';
import { Content, Buttons } from './../../../components/includes/container';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { stringifyQueryString, parseQueryString } from './../../../utilities/utils';

const validate = values => {

  const errors = {}

  return errors;

}

class PageContentFilter extends React.Component {

  componentDidMount(){

    const search = parseQueryString(this.props.location.search);

    Object.entries(search).forEach(([key,value]) => {
      this.props.dispatch(change('PageContentFilter', key, value));
    });

  }

  /*
  ** @Submit
  ** @Description: Submit filter form
  */

  handleSubmitForm = (values) => {
    this.props.history.push(`/page-content?${ stringifyQueryString(values) }`);
    if (this.props.onSuccess) {
        this.props.onSuccess();
    }
  }

  render() {

    const { handleSubmit } = this.props;

    return(

      <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

        <Content style={{paddingLeft:0, paddingRight:0}}>
          <Grid container spacing={8}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Field
                  name="title"
                  component={ InputTextField }
                  label="Título"
                  type="text"
                  autoFocus
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
                <Field
                    name="sortField"
                    component={SelectField}
                    label="Campo" required>
                    <OptionField key="name" value="name">Nombre</OptionField>
                    <OptionField key="created_at" value="created_at">Creado</OptionField>
                    <OptionField key="updated_at" value="updated_at">Editado</OptionField>
                </Field>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
                <Field
                    name="sortOrder"
                    component={SelectField}
                    label="Orden" required>
                    <OptionField key="1" value="1">Ascendente</OptionField>
                    <OptionField key="-1" value="-1">Descendente</OptionField>
                </Field>
            </Grid>
          </Grid>
        </Content>

        <Content style={{padding:0}}>
          <Buttons align="right">
            <Btn aria-label="Aplicar" icon="save" color="primary" type="submit">
              Aplicar
            </Btn>
          </Buttons>
        </Content>

      </form>

    )
  }

}

PageContentFilter = reduxForm({
  form: 'PageContentFilter',
  validate,
  initialValues: {
    'sortField': 'created_at',
    'sortOrder': -1
  },
  enableReinitialize: true
})(PageContentFilter);

export default withRouter(PageContentFilter);
